import Marquee from "react-fast-marquee";
import { MARQUEE } from "@/lib/content";

export const BrandMarquee = () => (
  <section data-testid="marquee" className="bg-[#1A1A1A] py-8 md:py-10 overflow-hidden">
    <Marquee speed={40} gradient={false} autoFill>
      {MARQUEE.map((item, i) => (
        <div key={i} className="flex items-center">
          <span className="marquee-serif text-[#FBF9F6] text-3xl md:text-5xl italic px-8 md:px-14">{item}</span>
          <span className="text-[#8C7A6B] text-2xl">✕</span>
        </div>
      ))}
    </Marquee>
  </section>
);
